import { createContext, useContext } from "react";

import type { StepperViewModel } from "./types-stepper";

export const StepperContext = createContext<StepperViewModel | null>(null);

export function useStepperContext(): StepperViewModel {
  const context = useContext(StepperContext);
  if (!context) throw new Error("Stepper.Step deve ser usado dentro de Stepper.Root");
  return context;
}
